import React from "react";
import { DiaryListColumns } from "../../Api/DiaryListColumns";
import List from "../../../../components/Listings/List";

export default function DiaryComponent(props) {
  const { card } = props;
  return (
    <div
      style={{
        height: card.height - 45,
        overflowY: "auto",
        paddingLeft: "15px",
      }}
    >
      <List
        url={"get/list/diary"}
        columns={DiaryListColumns()}
        pagination={false}
        sort={false}
        defaultSort={"startTime"}
        defaultIndex={"startTime"}
        defaultSearchColumn={"clearedBy"}
        defaultSortType={"DESC"}
        defaultSearchValue={null}
        defaultPageSize={4}
      />
    </div>
  );
}
